import JSZip from 'jszip';
import FileSaver from 'file-saver';
import cssbeautify from 'cssbeautify'

export default (editor, opts = {}) => {
  let pfx = editor.getConfig('stylePrefix');
  let btnExp = document.createElement('button');
  let commandName = 'gjs-export-zip';
  let defaultStyle = `.CTATAudioButton{    width: 155px;    height: 30px;}.CTATButton {    width: 60px;    height: 30px;}.CTATCheckBox {    width: 100px;    height: 30px;}.CTATComboBox {    width: 100px;    height: 30px;}.CTATGroupingComponent {    width: 100px;    height: 100px;}.CTATGroupingComponent > * {    width: inherit;}.CTATJumble {    width: 150px;    height: 40px;}.CTATRadioButton {    width: 100px;    height: 30px;}.CTATSubmitButton {    width: 60px;    height: 30px;}.CTATTextField {    width: 200px;    height: 30px;}.flexrow{    width: 100%;    height: 100px;    display: flex;    flex-direction: row;}.flexcolumn > *{    width: 100%;    }.flexrow > * {    height: 100%;}.flexcolumn{    height: 300px;    width: 100px;    display: flex;    flex-direction: column;}.flexbox{    width:100px;    height: 100px;    display:flex;}hr {    width: 100px;    height: 0px;    margin-top: 10px;    margin-bottom:10px;}table {    width: 100%;    height: 100px;    border-collapse: collapse;}p {    font: Helvetica;    margin-top: 0px;    margin-bottom: 0px;}.tablehead > *, .tablecell >* {    width: 100%;}`;

  let config = {
    addExportBtn: 1,
    btnLabel: 'Export to ZIP',
    filenamePfx: 'CTATHTML',
    filename: null,
    root: {
      css: {
        'style.css': ed => cssbeautify(ed.getCss()),
        'default.css': cssbeautify(defaultStyle),
      },
      'index.html': ed => {
        const canvas = ed.Canvas;
        var iframeHTML = canvas.getDocument().cloneNode(true);
        let list = iframeHTML.querySelectorAll("div[class^='CTAT']");
        for (var index = 0; index < list.length; index++) {
          while ((!(list[index].classList.contains('CTATTextField') || list[index].classList.contains('CTATGroupingComponent'))) && list[index].firstChild) {
            list[index].removeChild(list[index].firstChild);
          }
        }
        const HTML = iframeHTML.getElementById('wrapper');

        function recusiveClean(div) {
          div.removeAttribute('draggable');
          div.removeAttribute('data-highlightable');
          div.removeAttribute('data-gjs-type');
          div.removeAttribute('contenteditable');
          div.removeAttribute('spellcheck');
          if (div.childNodes) {
            for (let element of div.children) {
              recusiveClean(element);
            }
          }
        }
        recusiveClean(HTML);

        function process(div) {
          return format(div, 5).innerHTML;
        }

        function format(node, level) {

          var indentBefore = new Array(level++ + 1).join('  '),
            indentAfter = new Array(level - 1).join('  '),
            textNode;

          for (var i = 0; i < node.children.length; i++) {

            textNode = document.createTextNode('\n' + indentBefore);
            node.insertBefore(textNode, node.children[i]);

            format(node.children[i], level);

            if (node.lastElementChild == node.children[i]) {
              textNode = document.createTextNode('\n' + indentAfter);
              node.appendChild(textNode);
            }
          }

          return node;
        }
        return `<!doctype html><html lang="en">
        <head>
        <meta charset="utf-8">
        <script type="text/javascript" src="https://cdn.ctat.cs.cmu.edu/html-editor/js/jquery.js">
        </script>
        <script  type="text/javascript"
            src="https://cdn.ctat.cs.cmu.edu/html-editor/js/jquery-ui.js"></script>
        <script type="text/javascript"
            src="https://cdn.ctat.cs.cmu.edu/releases/CTAT_4_5/ctatloader.js"></script>
        <script type="text/javascript"
            src="https://cdn.ctat.cs.cmu.edu/releases/CTAT_4_5/ctat.min.js"></script>
        <link href="https://cdn.ctat.cs.cmu.edu/releases/CTAT_4_5/CTAT.css" rel="stylesheet">
        <link rel="stylesheet" href="./css/default.css">
        <link rel="stylesheet" href="./css/style.css">
        </head>
          <body>${process(HTML)}</body>
        <html>`;
      },
    },
    isBinary: null,
    ...opts,
  };

  btnExp.innerHTML = config.btnLabel;
  btnExp.className = `${pfx}btn-prim`;

  // Add command
  editor.Commands.add(commandName, {
    createFile(zip, name, content) {
      const opts = {};
      const ext = name.split('.')[1];
      const isBinary = config.isBinary ?
        config.isBinary(content, name) :
        !(ext && ['html', 'css'].indexOf(ext) >= 0) &&
        !/^[\x00-\x7F]*$/.test(content);

      if (isBinary) {
        opts.binary = true;
      }

      editor.log(['Create file', {
        name,
        content,
        opts
      }], {
        ns: 'plugin-export'
      });

      zip.file(name, content, opts);
    },

    async createDirectory(zip, root) {
      root = typeof root === 'function' ? await root(editor) : root;

      for (const name in root) {
        if (root.hasOwnProperty(name)) {
          let content = root[name];
          content = typeof content === 'function' ? await content(editor) : content;
          const typeOf = typeof content;

          if (typeOf === 'string') {
            this.createFile(zip, name, content);
          } else if (typeOf === 'object') {
            const dirRoot = zip.folder(name);
            await this.createDirectory(dirRoot, content);
          }
        }
      }
    },

    run(editor) {
      const zip = new JSZip();
      this.createDirectory(zip, config.root).then(() => {
        zip.generateAsync({
            type: 'blob'
          })
          .then(content => {
            const filenameFn = config.filename;
            let filename = filenameFn ?
              filenameFn(editor) : `${config.filenamePfx}_${Date.now()}.zip`;
            FileSaver.saveAs(content, filename);
          });
      });
    }
  });

  // Add button inside export dialog
  if (config.addExportBtn) {
    editor.on('run:export-template', () => {
      editor.Modal.getContentEl().appendChild(btnExp);
      btnExp.onclick = () => {
        editor.runCommand(commandName);
      };
    });
  }

  editor.Panels.removeButton('options', "export-template");

  editor.Panels.addButton('options', {
    id: 'downloadButton',
    className: 'fa fa-download',
    command: commandName
  });
    
};